import { Livestream, Media, User } from '../../types/__generated__';
import { MIXER, TWITCH, YOUTUBE } from '../constants';

export function getStreamDetails(
  livestream: Livestream | null | undefined,
  owner: User | null | undefined,
  heroMedia?: Media | null,
) {
  const livestreamAsHeroMedia =
    heroMedia?.__typename === 'LivestreamMedia' && heroMedia;

  if (typeof window === 'undefined') {
    return;
  }
  if (livestreamAsHeroMedia) {
    return {
      title: createTitle(owner?.name, livestreamAsHeroMedia.platform),
      streamUrl: createUrl(
        livestreamAsHeroMedia?.platform,
        livestreamAsHeroMedia?.streamId,
      ),
      chatUrl: createChatUrl(
        livestreamAsHeroMedia?.platform,
        livestreamAsHeroMedia?.streamId,
      ),
    };
  }
  const streamEntries = livestream?.entries;
  if (!streamEntries || streamEntries.length === 0) {
    return null;
  }

  const firstEntry = streamEntries[0];
  return {
    title: createTitle(owner?.name, firstEntry?.streamType),
    streamUrl: createUrl(firstEntry?.streamType, firstEntry?.streamId),
    chatUrl: createChatUrl(firstEntry?.streamType, firstEntry?.streamId),
  };
}

const createTitle = (
  ownerName: string | null | undefined,
  streamType: string | null | undefined,
) => {
  if (!ownerName || !streamType) {
    return null;
  }

  return `${ownerName}'s ${streamType} stream`;
};

const createChatUrl = (
  streamType: string | null | undefined,
  streamId: string | null | undefined,
) => {
  if (!streamId) {
    return null;
  }

  switch (streamType) {
    case TWITCH:
      return `https://www.twitch.tv/embed/${streamId}/chat?parent=${window.location.host}`;
    case YOUTUBE:
      return `https://www.youtube.com/live_chat?v=${streamId}&embed_domain=${window.location.host}`;
    default: {
      return null;
    }
  }
};

export const createUrl = (
  streamType: string | null | undefined,
  streamId: string | null | undefined,
) => {
  if (!streamId) {
    return null;
  }

  switch (streamType) {
    case TWITCH:
      return typeof window !== 'undefined'
        ? `https://player.twitch.tv/?channel=${streamId}&parent=${window.location.host}`
        : `https://player.twitch.tv/?channel=${streamId}`;
    case MIXER:
      return `https://mixer.com/embed/player/${streamId}`;
    case YOUTUBE:
      return `https://www.youtube.com/embed/${streamId}?autoplay=1&playsinline=1`;
    default: {
      return null;
    }
  }
};

export default getStreamDetails;
